import { useEffect, useState }         from 'react'
import { memberService } from "../services";
import { useLocation }                 from "react-router";
import { useDefaultLimit }             from "./WindowUtil";

const getNumberOrDefault = (value, defaultValue) => {
  const number = parseInt(value, 10);
  return Number.isFinite(number) ? number : defaultValue;
};

export const useMemberList = (onlyWithSite) => {

  const {defaultLimit} = useDefaultLimit()
  const [members, setMembers] = useState([]);
  const [pagination, setPagination] = useState({limit: defaultLimit, skip: 0, filterName: "", columnSort: "Name", descending: false});

  const getMembers = (limit = pagination.limit, skip = pagination.skip, filterName = pagination.filterName, columnSort = pagination.columnSort, descending = pagination.descending) => {
    const safeLimit = getNumberOrDefault(limit, defaultLimit || 10);
    const safeSkip = getNumberOrDefault(skip, 0);

    memberService()
      .getMembers(safeLimit, safeSkip, filterName || "", columnSort || "Name", descending, onlyWithSite)
      .then(res => {
        if (res && res.data) {
          setMembers(res.data);
          const memberPaginationList = {
            ...pagination,
            count: getNumberOrDefault(res.headers['x-total-count'], 0),
            limit: getNumberOrDefault(res.headers['x-total-limit'], safeLimit),
            skip: getNumberOrDefault(res.headers['x-total-skip'], safeSkip),
            columnSort: columnSort || "Name",
            descending,
            filterName: filterName || ""
          }
          setPagination(memberPaginationList)
          sessionStorage.setItem("memberPaginationList" + (onlyWithSite || ""), JSON.stringify(memberPaginationList))
        }
      })
  };

  useEffect(() => {
    let memberPaginationList = sessionStorage.getItem("memberPaginationList" + (onlyWithSite || ""));
    if (memberPaginationList) {
      memberPaginationList = JSON.parse(memberPaginationList)
      const safePagination = {
        ...memberPaginationList,
        limit: getNumberOrDefault(defaultLimit || memberPaginationList.limit, 10),
        skip: getNumberOrDefault(memberPaginationList.skip, 0),
        filterName: memberPaginationList.filterName || "",
        columnSort: memberPaginationList.columnSort || "Name",
        descending: typeof memberPaginationList.descending === "undefined" ? false : memberPaginationList.descending
      };
      setPagination(safePagination)
      getMembers(safePagination.limit, safePagination.skip, safePagination.filterName, safePagination.columnSort, safePagination.descending)
    } else {
      getMembers()
    }
    return () => {
      if (onlyWithSite) {
        sessionStorage.removeItem("memberPaginationList" + onlyWithSite)
      }
    }
    // eslint-disable-next-line
  }, []);

  return {members, pagination, getMembers}
};

export const useMember = (props) => {

  const {id, onChange} = props || {};

  const location = useLocation();
  let param = new URLSearchParams(location.search);
  const memberParamId = param.get("member");

  const [member, setMember] = useState({});

  const getMember = (memberId) => {
    if (memberId || id || memberParamId) {
      memberService()
        .getMember({id: memberId || id || memberParamId})
        .then(res => {
          if (res && res.data) {
            setMember(res.data);
            if (onChange) {
              onChange(res.data);
            }
          }
        })
        .catch(err => {
          setMember({});
          if (onChange) {
            onChange({});
          }
        })
    }
  };

  useEffect(() => {
    if (member.id !== memberParamId) {
      getMember()
    }
    // eslint-disable-next-line
  }, [memberParamId, id]);

  return {
    member,
    setMember,
    getMember,
    memberId: memberParamId
  }
};
